import { FilterList } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';
import { ListActionProps } from 'src/careflow/common/ListAction/ListAction';
import { iconGreyFillColor } from 'src/careflow/helpers/constants';
import SearchTextField from 'src/components/SearchTextField';
import { spreadSxProp } from 'src/utils/cssStyles';

export default function FhirOrganizationTableToolbar({
  searchTextFieldProps,
  containerSx,
  childrenFilter,
}: ListActionProps) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Box
      sx={[
        {
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          position: 'relative',
          justifyContent: 'space-between',
        },
        ...spreadSxProp(containerSx),
      ]}
    >
      <SearchTextField
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="animatedTextField"
        {...(searchTextFieldProps ?? {})}
      />
      <Box sx={{ zIndex: 1, display: 'flex', flexDirection: 'row', float: 'right' }}>
        {childrenFilter ? (
          childrenFilter
        ) : (
          <IconButton>
            <FilterList htmlColor={iconGreyFillColor} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
